<!-- 构建投资组合 -->
<template>
  <div class="goujiantouzizuhe-layer">
    <div class="container">
      <!-- 左侧内容 -->
      <div class="left-section">
        <!-- 饼图容器 -->
        <div class="chart-container">
          <div ref="chartRef" class="pie-chart"></div>
        </div>

        <!-- 滑动进度条 -->
        <div class="sliders-container">
          <!-- 五个产品投资权重输入 -->
          <div class="slider-item">
            <div v-for="product in products" :key="product.id">
              <div class="slider-label" style="margin-bottom: 10px;">{{ product.name }}（%）</div>
              <el-input-number :min="0" :max="getMaxValue(product.id)" v-model.number="productWeights[product.id]"
                               class="ipt" @input="updateProductWeight($event, product.id)">
                <template slot="append">%</template>
              </el-input-number>
            </div>
            <div>
              <!-- <el-button type="primary" @click="resetWeights">重置</el-button> -->
              <button class="generate-report-btn" @click="resetWeights">重置</button>
            </div>
          </div>

          <!-- 债券类 -->
          <div class="slider-item">
            <div class="slider-label">拖动滑块可调整投资金额</div>
            <input type="range" min="1000" max="10000000" step="100000" v-model.number="investmentAmount"
                   class="slider">
            <div class="slider-value">{{ formatNumber(investmentAmount) }}元</div>
          </div>

          <!-- 投资期限 -->
          <div class="slider-item">
            <div class="slider-label">拖动滑块可调整投资期限</div>
            <input type="range" min="1" max="120" v-model.number="investmentPeriod" class="slider">
            <div class="slider-value">{{ investmentPeriod }}月</div>
          </div>
        </div>
      </div>

      <!-- 右侧内容 -->
      <div class="right-section">
        <!-- 投资组合类型标签 -->
        <div class="portfolio-type">
          R1 保守型: 股票类{{ stockPercentage }}% +债券类{{ bondPercentage }}% +现金类{{ cashPercentage }}%
        </div>
        <!-- 投资产品列表 -->
        <div class="product-list">
          <div class="product-item" v-for="product in products" :key="product.id">
            <div class="product-info">
              <div class="product-icon" :style="{ backgroundColor: product.color }"></div>
              <div class="product-name">{{ product.name }}</div>
            </div>
            <div class="product-details">
              <div class="product-return">年化收益: {{ product.return }}%</div>
              <div class="product-weight">权重{{ productWeights[product.id] }}%</div>
            </div>
          </div>
        </div>

        <button class="generate-report-btn" @click="handleClick">生成投顾报告</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GoujianTouzizuhe',
  components: {},
  props: {},
  data () {
    return {
      stockPercentage: 10,
      bondPercentage: 40,
      cashPercentage: 50,
      // 产品权重对象
      productWeights: {
        1: 20, // 天弘余额宝货币基金
        2: 30, // 招商招钱宝货币A
        3: 20, // 易方达增强回报债券A
        4: 20, // 南方元宝债券A
        5: 10  // 华夏沪深300ETF联接A
      },
      // 投资金额
      investmentAmount: 1000,
      // 投资期限（月）
      investmentPeriod: 1,
      // 图表实例
      chartInstance: null,
      // 产品数据
      products: [
        {
          id: 1,
          name: '天弘余额宝货币基金',
          return: 2.5,
          color: '#1549F3'
        },
        {
          id: 2,
          name: '招商招钱宝货币A',
          return: 2.5,
          color: '#00D5C4'
        },
        {
          id: 3,
          name: '易方达增强回报债券A',
          return: 4.2,
          color: '#FCC200'
        },
        {
          id: 4,
          name: '南方元宝债券A',
          return: 4.0,
          color: '#8352E2'
        },
        {
          id: 5,
          name: '华夏沪深300ETF联接A',
          return: 6.5,
          color: '#36CFC9'
        }
      ]
    }
  },
  computed: {},
  watch: {},
  created () { },
  mounted () {
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);

    // 确保窗口完全加载后再初始化图表，避免尺寸问题
    if (document.readyState === 'complete') {
      this.$nextTick(() => {
        this.initChart();
      });
    } else {
      window.addEventListener('load', () => {
        this.$nextTick(() => {
          this.initChart();
        });
      });
    }
  },
  beforeDestroy () {
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleClick () {
      this.$emit('next', 'tgbg')
    },
    resetWeights () {
      // 重置所有产品权重为20%
      Object.keys(this.productWeights).forEach(key => {
        this.productWeights[key] = 0;
      });
      // 重置投资金额和期限
      this.investmentAmount = 1000;
      this.investmentPeriod = 1;
      // 重新初始化图表
      this.initChart();
    },
    // 初始化图表
    initChart () {
      if (!this.$refs.chartRef) return;

      // 强制设置图表容器的宽高
      const chartContainer = this.$refs.chartRef;
      chartContainer.style.width = '500px';
      chartContainer.style.height = '400px';

      // 获取echarts实例
      this.chartInstance = this.$echarts.init(chartContainer);

      // 设置图表配置
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c}%'
        },
        legend: {
          orient: 'horizontal',
          bottom: '0',
          textStyle: {
            color: '#b8c4e0',
            fontSize: 12
          }
        },
        series: [
          {
            name: '投资组合',
            type: 'pie',
            radius: ['30%', '80%'],
            center: ['50%', '45%'],
            roseType: 'radius', // 设置为玫瑰图
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 4,
              borderColor: '#000624',
              borderWidth: 2
            },
            label: {
              show: true,
              fontSize: 12,
              color: '#b8c4e0',
              formatter: '{b}\n{c}%'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 14,
                fontWeight: 'bold'
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            data: this.getChartData()
          }
        ]
      };

      // 设置配置项
      this.chartInstance.setOption(option);
    },

    // 获取图表数据
    getChartData () {
      return this.products.map(product => ({
        value: this.productWeights[product.id],
        name: product.name,
        itemStyle: { color: product.color }
      }));
    },

    // 获取当前产品的最大可输入值
    getMaxValue (productId) {
      // 确保productId是数字类型，与parseInt(id)类型一致
      const targetProductId = Number(productId);
      // 计算其他产品的权重总和
      let otherProductsTotal = 0;

      for (const id in this.productWeights) {
        // 确保id类型一致后再比较
        if (Number(id) !== targetProductId) {
          // 确保权重值是有效数字，防止NaN问题
          const weight = Number(this.productWeights[id]) || 0;
          otherProductsTotal += weight;
        }
      }

      // 最大可输入值 = 100% - 其他产品权重总和，并确保不小于0
      const maxValue = 100 - otherProductsTotal;
      return Math.max(0, maxValue);
    },

    // 更新产品权重
    updateProductWeight (event, productId) {
      // 注意：使用el-input-number组件时，event可能直接是数值而非事件对象
      let inputValue = typeof event === 'number' ? event : parseFloat(event);

      // 处理非数字输入和空输入
      if (isNaN(inputValue) || inputValue === null || inputValue === undefined) {
        inputValue = 0;
      }

      // 获取最大值
      const maxValue = this.getMaxValue(productId);

      // 确保值在有效范围内（0到maxValue）
      const actualValue = Math.max(0, Math.min(inputValue, maxValue));

      // 直接更新数据模型
      this.productWeights[productId] = actualValue;

      // 使用setTimeout确保在DOM和数据更新完成后刷新图表
      // 这对于确保图表正确响应数据变化非常重要
      setTimeout(() => {
        // 确保图表实例存在再更新
        if (this.chartInstance) {
          // 强制重新获取最新数据并更新图表
          const updatedData = this.getChartData();
          this.chartInstance.setOption({
            series: [{
              data: updatedData
            }]
          });
          // console.log('图表已更新，最新数据:', updatedData);
        }
      }, 100); // 稍微延迟以确保数据完全更新
    },

    // 格式化数字
    formatNumber (num) {
      if (num >= 10000) {
        return (num / 10000).toFixed(1) + '万';
      }
      return num.toString();
    },

    // 响应式调整
    handleResize () {
      if (this.chartInstance && this.$refs.chartRef) {
        // 先设置容器尺寸，再调用resize
        const chartContainer = this.$refs.chartRef;
        const parentWidth = chartContainer.parentElement.clientWidth;
        // 根据父容器宽度动态调整图表尺寸
        const chartWidth = Math.min(parentWidth - 40, 600); // 减去padding
        chartContainer.style.width = `${chartWidth}px`;

        this.chartInstance.resize();
      }
    }
  }
}
</script>

<style scoped lang="less">
.goujiantouzizuhe-layer {
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  color: #fff;
}

.container {
  display: flex;
  // height: 100%;
  height: calc(100% - 40px);
  gap: 30px;
}

.left-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.right-section {
  width: 400px;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.chart-container {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 12px;
  border: 1px solid rgba(21, 73, 243, 0.2);
  padding: 20px;
  flex: 1;
  position: relative;
}

.pie-chart {
  height: 400px;
  width: 500px;
  /* 设置固定初始宽度 */
  min-width: 400px;
  max-width: 600px;
  margin: 0 auto;
  position: relative;
}

.portfolio-type {
  font-size: 16px;
  color: #1549F3;
  font-weight: bold;
  text-align: center;
}

.sliders-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 12px;
  border: 1px solid rgba(21, 73, 243, 0.2);
  padding: 20px;
}

.slider-item {
  display: flex;
  align-items: center;
  gap: 15px;
}

.slider-label {
  flex: 1;
  font-size: 14px;
  color: #b8c4e0;

  // 自定义el-input-number的增减按钮颜色
  /deep/.el-input-number__decrease,
  /deep/.el-input-number__increase {
    color: rgba(0, 0, 0, 0.3) !important;
  }
}

.ipt {
  width: 150px;

  /deep/.el-input-group__append {
    background: rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    border: 1px solid rgba(21, 73, 243, 0.2) !important;
    padding: 8px 12px;
    font-size: 14px;
    color: #fff;
  }
}

.slider {
  flex: 2;
  height: 6px;
  border-radius: 3px;
  background: rgba(21, 73, 243, 0.2);
  outline: none;
  -webkit-appearance: none;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #1549F3;
  cursor: pointer;
  border: 2px solid #fff;
}

.slider::-moz-range-thumb {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #1549F3;
  cursor: pointer;
  border: 2px solid #fff;
}

.slider-value {
  font-size: 14px;
  font-weight: bold;
  color: #fff;
  min-width: 60px;
  text-align: right;
}

.product-list {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 12px;
  border: 1px solid rgba(21, 73, 243, 0.2);
  padding: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.product-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 8px;
}

.product-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.product-icon {
  width: 20px;
  height: 20px;
  border-radius: 4px;
}

.product-name {
  font-size: 14px;
  color: #fff;
}

.product-details {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.product-return,
.product-weight {
  font-size: 12px;
  color: #b8c4e0;
}

.generate-report-btn {
  padding: 12px 40px;
  font-size: 16px;
  font-weight: bold;
  background: #1549F3;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(21, 73, 243, 0.3);
  align-self: center;
}

.generate-report-btn:hover {
  background: #1549F3;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(21, 73, 243, 0.5);
}

.generate-report-btn:active {
  transform: translateY(0);
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .container {
    flex-direction: column;
  }

  .right-section {
    width: 100%;
  }
}
</style>
